import { _,moment,Backbone,Radio,$ } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import { Backform,Biscuit,FormatHelper,Notification } from '../../utils'
import XLSX from 'xlsx'
import { appRollingLoaderAnim } from '../AppAnnouncements'
import VoucherType from '../../models/VoucherType'
import Voucher from "../../models/Voucher"
import OffCanvasVouchersFormTpl from '../../templates/vouchers/OffCanvasVouchersFormTpl.html'
import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";
import {getApiHost, getRequestHeaders} from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";

export default InboomaBaseView.extend({

    template: OffCanvasVouchersFormTpl,
    parentView: 'vouchers',
    el: '#inb-off-canvas',
    ui : {
        exportButton: '.button-export',
        formErrorDiv : '.off-canvas__form-error'
    },
    templateContext () {
        return {
            client_id: Biscuit.get('user.client_id')
        }
    },
    events : {
        'click @ui.exportButton' : '_export_vouchers'
    },
    initialize () {

        this.isNew = (this.model.get('id') === '');
        this.eventListeners = [];
        this.render();

    },

    behaviors: [
        {
            behaviorClass: OffCanvasBehavior,
            openCanvas: (view) => {
                if (typeof view.options.openCanvas != 'undefined') {
                    return view.options.openCanvas;
                }
                return true;
            },
            beforeSave: (model, view) => {

                if (model.get('id') === null) {
                    model.set('client_id', Number(Biscuit.get('user.client_id')));
                }

                model.set('sellable', + model.get('sellable'));
                model.set('valid_to', moment(model.get('valid_to')).format('YYYY-MM-DD')+" 23:59:59");

                delete model.attributes.vouchers;
                delete model.attributes.codes_file;
            },
            afterSaveSuccess: (model, view, response) => {

                let isCreating = response.data.id !== undefined;

                model = new VoucherType(model.toJSON());

                if (model.get('created') == '' || _.isNull(model.get('created'))) {
                    model.set('created', moment().toISOString());
                }

                if (model.get("codes_source") !== 'none') {
                    const voucher = new Voucher(
                        model.get("codes_source") === "generate" ?
                        {
                            'voucher_type_id': model.get('id'),
                            'client_id': model.get('client_id'),
                            'amount': model.get('codes_generate_count'),
                            'length': 5,
                        } :
                        {
                            'voucher_type_id': model.get('id'),
                            'client_id': model.get('client_id'),
                            'codes': model.get('codes').map((codeItem) => ({code: codeItem})),
                        });

                    voucher.save(null, {
                        type: 'POST',
                        success (__, data) {
                            // Update both, vouchertype.model AND vouchers-collection
                            // so that vouchers become available
                            model.fetch();
                            
                            const vouchers = Radio.channel('vouchers').request('get:data');

                            _.each(data.data, (_voucher) => {
                              vouchers.set(_voucher, {add:true,merge:true,remove:false});
                            });

                        }
                    });
                }

                if (typeof view.collection !== 'undefined') {
                    view.collection.set(model, {add: true, merge: true, remove: false});
                }

                new Notification({
                    message: view.t((view.isNew ? 'saved_${a}' : 'updated_${a}'), {a: view.t('voucher')}, 'capital') + ' "' + model.get('name') + '".',
                    duration: 5000,
                    type: 'success',
                    closeable: true,
                    icon: 'fi fi-check'
                });
            },

            afterSaveError: (model, view, response) => {

                view.$el.find('.rollingLoader').fadeOut('fast');

                const data = response.responseJSON.data;

                let message = view.t('request_error');

                if (typeof data !== 'undefined'
                 && typeof data.errors !== 'undefined'
                 && typeof data.errors.voucher_value !== 'undefined'
                 && typeof data.errors.voucher_value.greaterThanOrEqual) {
                    message = view.t('voucher_error_value_greater_equal')
                }

                new Notification({
                    message,
                    duration : 6000,
                    type : 'warning',
                    closeable : true,
                    icon : 'fi fi-x'
                });
                
            }
        }
    ],

    onRender () {
        
        const that = this,
              formErrorDiv = this.getUI('formErrorDiv');

        const ContingentsRequest = Backbone.Model.extend({
            urlRoot: '/contingents/findForSelect=true'
        });

        const getContingentLabel = (contingent) => {
            return (contingent.locations && contingent.locations.length ? contingent.locations[0].name + " : " : "") +
                contingent.name + FormatHelper.formatContingentTags(contingent.tags);
        };

        const contingents = _.map(this.model.get('contingents'), (contingent) => ({
            value: contingent.id,
            label: getContingentLabel(contingent),
        }));

        let fields = [
            {
                name: "name",
                label: this.t('name', null, 'capital'),
                control: "input",
                required: true,
                size: {
                    large: "3",
                    medium: "4",
                }
            },
            {
                name: "type",
                label: this.t('type', null, 'capital'),
                control: "select",
                required: true,
                options: [
                    {label: this.t('voucher_type_discount'), value: 'discount'},
                    {label: this.t('voucher_type_gift_card'), value: 'gift_card'},
                ],
                size: {
                    "large": "3"
                },
            },
            {
                label: "",
                control: 'help',
                size: {
                    large: "6",
                    medium: "5",
                }
            },
            {
                name: "valid_to",
                label: this.t('voucher_type_valid_to', null, 'capital'),
                control: "datepicker",
                value: null,
                allowEmpty: true,
                size: {
                    large: "3",
                    medium: "4",
                }
            },
            {
                name: "status",
                label: this.t('active', null, 'capital'),
                control: "boolean",
                value: true,
                size: {
                    "large": "1"
                }
            },
            {
                name: "sellable",
                label: this.t('sellable'),
                visible: (model) => model.get("type") === "gift_card",
                control: Backform.BooleanControl.extend({
                    initialize: function() {
                        Backform.InputControl.prototype.initialize.apply(this, arguments);
                        this.listenTo(this.model, "change:type", this.render);
                    }
                }),
                value: true,
                size: {
                    "large": "1"
                }
            },
            {
                name: "multiple_use",
                label: this.t('multiple_use'),
                control: "boolean",
                value: true,
                size: {
                    "large": "3"
                }
            },
            {
                name: "use_for",
                label: this.t('use_for'),
                control: "select",
                required: true,
                options: [
                    {label: this.t('contingent'), value: 'contingent'},
                    {label: this.t('reservation'), value: 'reservation'},
                ],
                size: {
                    "large": "3"
                }
            },
            {
                name: "description",
                label: this.t('description',null,'capital'),
                control: "textarea",
                size : {
                    "small" : "12"
                }
            },
            {
                name: "voucher_unit",
                label: this.t('voucher_unit', null, 'capital'),
                control: "select",
                required: true,
                options: [
                    {label: this.t('voucher_unit_percentage'), value: 'percentage'},
                    {label: this.t('voucher_unit_fix_price'), value: 'fix_price'},
                ],
                size: {
                    "large": "3"
                }
            },
            {
                name: "voucher_value",
                label: this.t('voucher_value', null, 'capital'),
                control: "input",
                required: true,
                type: "number",
                minValue: "0",
                size: {
                    large: "3"
                }
            },
            {
                label: "",
                control: 'help',
                size: {
                    large: "6"
                }
            },
            {
                name: "days_number",
                label: this.t('days_number', null, 'capital'),
                control: "input",
                type: "number",
                minValue: "0",
                size: {
                    large: "3"
                }
            },
            {
                label: "",
                control: 'help',
                size: {
                    large: "9"
                }
            },
            {
                name: "contingent_number",
                label: this.t('contingent_number', null, 'capital'),
                control: "input",
                type: "number",
                minValue: "0",
                size: {
                    large: "3"
                }
            },
            {
                name: "contingents",
                label: this.t('contingents', null, 'capital'),
                hasMultiple: () => 999,
                control: 'selector',
                options: contingents,
                extraTopClasses: ["select2-show-search-input"],
                select2Options: {
                    rememberSearch: true,
                    closeOnSelect: false,
                    ajax: {
                        url: getApiHost() + '/contingents?findForSelect=true',
                        headers: getRequestHeaders(),
                        dataType: 'json',
                        delay: 250,
                        data: (params) => ({
                            q: params.term,
                            limit: 1000,
                        }),
                        processResults: (data, params) => ({
                            results: _.map(data.data, item => ({
                                id: item.id,
                                text: item.name
                            }))
                        }),
                    },
                    minimumInputLength: 0,
                    casesensitive: false
                },
                size: {
                    large: "9"
                },
            },
            {
                control: "spacer"
            },
            {
                name: "codes_source",
                label: this.t('voucher_codes_source', null, 'capital'),
                control: "select",
                required: true,
                options: [
                    {label: this.t('voucher_codes_none'), value: 'none'},
                    {label: this.t('voucher_codes_enter_as_text'), value: 'text'},
                    {label: this.t('voucher_codes_upload_file'), value: 'file'},
                    {label: this.t('voucher_codes_generate'), value: 'generate'},
                ],
                size: {
                    "large": "4"
                }
            },
            {
                name: "codes_generate_count",
                label: this.t('voucher_codes_generate_count', null, 'capital'),
                visible: (model) => model.get("codes_source") === "generate",
                control: Backform.InputControl.extend({
                    initialize: function() {
                        Backform.InputControl.prototype.initialize.apply(this, arguments);
                        this.listenTo(this.model, "change:codes_source", this.render);
                    }
                }),
                type: "number",
                size: {
                    "large": "2"
                }
            },
            {
                name: "codes_file",
                label: this.t('codes_file', null, 'capital'),
                visible: (model) => model.get("codes_source") === "file",
                control: Backform.InputControl.extend({
                    initialize: function() {
                        Backform.InputControl.prototype.initialize.apply(this, arguments);
                        this.listenTo(this.model, "change:codes_source", this.render);
                    }
                }),
                required: false,
                type: "file",
                helpMessage: this.t("select_xlsx_file"),
                size: {
                    large: "8"
                }
            },
            {
                name: "codes_area",
                label: this.t('voucher_codes_new', null, 'capital'),
                visible: (model) => model.get("codes_source") !== "generate" && model.get("codes_source") !== "none",
                required: (model) => model.get("codes_source") !== "generate" && model.get("codes_source") !== "none",
                control: Backform.TextareaControl.extend({
                    initialize: function() {
                        Backform.InputControl.prototype.initialize.apply(this, arguments);
                        this.listenTo(this.model, "change:codes_source", this.render);
                    }
                }),
                helpMessage: this.t("enter_codes_separate_by"),
                size: {
                    "large": "12"
                }
            },
            {
                control: "spacer"
            }
        ];

        if (that.model.get('id')) {


            fields.push({
                name: "vouchers",
                label: this.t('voucher_codes', null, 'capital'),
                disabled: true,
                hasMultiple: () => 999,
                control: 'selector',
                rawValue: [1,2,3],
                options: this.model.get('vouchers').map((item) => ({
                    label: item.voucher_code,
                    value: item.id,
                })),
                extraClasses: ["codes"],
                size: {
                    large: "12"
                },
                helpMessage: "In den Klammern hinter dem Gutscheincode wird angezeigt, wie viele dieser Gutscheine bereits verwendet wurden. Bsp.: SOMMER (10) - Der Gutscheincode SOMMER wurde bereits 10 mal angewendet."
            });
            fields.push({
                control: "spacer"
            });

        }

        this.form = new Backform.Form({

            el: that.$el.find('form'),
            model: this.model,
            fields: fields,
            events: {
                "change input[name=codes_file]": (e) => {

                    let files = e.target.files, f = files[0];
                    let reader = new FileReader();

                    reader.onload = function(e) {
                        let data = e.target.result;
                        let workbook = XLSX.read(data, {type: 'binary'});
                        let result = [];

                        workbook.SheetNames.forEach(function(sheetName) {
                            let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {header:1});
                            roa.forEach((rowData) => {
                                rowData.forEach((cellData) => {
                                    result = result.concat(String(cellData).replace(/\s/g, ''));
                                });
                            });
                        });
                        result = _.sortBy(_.uniq(result));
                        that.model.set('codes_area', result.join("; "));
                    };

                    reader.readAsBinaryString(f);
                },
                "contextmenu .select2-selection__choice": (e) => {
                    e.preventDefault();
                    formErrorDiv.addClass('hide');
                    // check if correct form element clicked
                    let element = e.target.parentNode;
                    const existingPopups = document.getElementsByClassName('inb-c-popup-window');
                    while (typeof element !== 'undefined' && element !== null) {
                        if (typeof element.classList !== 'undefined' && element.classList.contains('vouchers')) {
                            let id = e.currentTarget.attributes._id;
                            let title = e.currentTarget.attributes.title;
                            let htmlContext = '<ul style="list-style-type: none;width: 100%;margin: 5px;margin-bottom: 10px;display: block;"><li class="context_menu_item" id="copy">'+that.t("copy_to_clipboard", null, 'capital')+'</li><hr style="max-height:1px;margin-top: -1px;"><li style="margin-top: -16px;" class="context_menu_item" _id="'+id.value+'" _title="'+title.value+'" id ="getQrCode">'+that.t('export vouchers', null, 'capital')+' </li><hr style="max-height:1px;margin-top: -1px;"><li style="margin-top: -16px;" class="context_menu_item" _id="'+id.value+'" _title="'+title.value+'" id ="delete">'+that.t('delete_${a}', {a:that.t('voucher')}, 'capital')+' </li> </ul>'

                            // open popup to copy code to clipboard
                            if (existingPopups.length === 0) {
                                let popup = document.createElement('div');
                                let info = document.createElement('div');
                                info.style.display = 'none';
                                info.innerHTML = e.target.title;
                                info.className = 'inb-c-popup-info';
                                popup.className = "inb-c-popup-window";
                                popup.innerHTML = htmlContext;
                                popup.appendChild(info);
                                popup.style.left = e.pageX + 5 + 'px';
                                popup.style.top = e.pageY - 25 + 'px';
                                document.body.appendChild(popup);
                            } else {
                                existingPopups[0].style.left = e.pageX + 5 + 'px';
                                existingPopups[0].style.top = e.pageY - 25 + 'px';
                            }
                            break;
                        } else element = element.parentNode;
                    }
                }
            }
        });

        this.form.render();
        // Take care that RBAC-methods are executed:
        this.onDomRefresh(this);

        // set voucher count
        var vouchersElements = $('.vouchers .select2-selection__rendered');
        const vouchers = (typeof this.model.get('vouchers') !== 'undefined' && this.model.get('vouchers') != null) ? this.model.get('vouchers') : [];
        console.log(vouchersElements);
        if(typeof this.model.get('id') !== 'undefined' && this.model.get('id') !== null && typeof vouchersElements[0] !== 'undefined'){vouchersElements = vouchersElements[0].childNodes;} else{vouchersElements=[];}
        for (var i=0,value;i<vouchersElements.length;i++) {
            if (vouchers.length > i) {
                value = vouchers[i].usage_count ? vouchers[i].usage_count : 0;
                vouchersElements[i].innerHTML += '<span style="color:grey;font-weight:bold"> (' + value + ')</span>';
                vouchersElements[i].setAttribute('_id', vouchers[i].id ? vouchers[i].id : null);
            }


            // initialize click event handler for info windows

            document.body.addEventListener('click', this.eventListeners['click'] = function (e) {
                onBodyClicked(e, that);
            });

            const onBodyClicked = (e, context) => {
                let id = e.target.attributes.id;
                const popups = document.getElementsByClassName('inb-c-popup-window');
                const info = document.getElementsByClassName('inb-c-popup-info');
                if (typeof id !== 'undefined') {
                    let double = false;
                    if (typeof lastId !== 'undefined' && lastId == id.value) {
                        double = true;
                    }
                    let lastId = id.value;
                    // clicked on popup
                    if (id.value == 'copy') {
                        const info = document.getElementsByClassName('inb-c-popup-info');
                        navigator.clipboard.writeText(info.length > 0 ? info[0].innerHTML : '').then(function () {
                        }, function (err) {
                            console.error('Error: Failed to copy to clipboard: ', err);
                        });
                    }
                    if (id.value == 'getQrCode' && !double) {
                        let title = e.target.attributes._title;
                        let _id = e.target.attributes._id;
                        that.$el.find('.button-submit')
                            .prepend(appRollingLoaderAnim);

                        const xmlHttp = new XMLHttpRequest();

                        xmlHttp.open("GET", getApiHost() + '/vouchers/getQRCode/' + _id.value /*+ slowup*/, true);

                        xmlHttp.setRequestHeader('Accept', 'image/png')
                        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
                        xmlHttp.responseType = "blob";

                        xmlHttp.onload = function () {

                            that.$('.button-submit img').remove();

                            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
                                formErrorDiv.html('getQrCode_error')
                                    .removeClass('hide');
                                return;
                            }

                            if (xmlHttp.status === 404 || typeof xmlHttp.response.size !== 'undefined' && xmlHttp.response.size === 1229) {
                                formErrorDiv.html(that.t('getQrCode_error_empty'))
                                    .removeClass('hide');
                                return;
                            }

                            const blob = new Blob([xmlHttp.response], {type: 'image/png'});
                            FileSaver.saveAs(blob, title.value + ".png");

                        };

                        xmlHttp.send(null);
                    }
                    if (id.value == 'delete' && !double) {
                        let title = e.target.attributes._title;
                        let _id = e.target.attributes._id;
                        if (confirm(context.t('really_delete_${a}', {a: title.value}, 'capital'))) {
                            const xmlHttp = new XMLHttpRequest();

                            xmlHttp.open("DELETE", getApiHost() + '/vouchers/' + _id.value, true);

                            xmlHttp.setRequestHeader('Accept', 'application/json')
                            xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
                            xmlHttp.responseType = "json";

                            xmlHttp.onload = function () {

                                that.$('.button-submit img').remove();

                                if (xmlHttp.status === 500 || xmlHttp.status === 400) {
                                    formErrorDiv.html('delete_voucher_error')
                                        .removeClass('hide');
                                    return;
                                }

                                if (xmlHttp.status === 404 || typeof xmlHttp.response.size !== 'undefined' && xmlHttp.response.size === 1229) {
                                    formErrorDiv.html(that.t('delete_voucher_error_empty'))
                                        .removeClass('hide');
                                    return;
                                }

                                if (xmlHttp.status === 200) {
                                    document.location.href = '/vouchers/' + context.model.get('id')
                                }

                            };

                            xmlHttp.send(null);

                        }
                    }
                    // close popup(s)
                    for (var i = popups.length - 1; i >= 0; i--) {
                        document.body.removeChild(popups[i]);
                    }
                } else if (!(e.target.classList.contains('select2-selection__choice') || e.target.parentNode.classList.contains('select2-selection__choice'))) {
                    // clicked outside of voucher field -> close popup(s)
                    for (var i = popups.length - 1; i >= 0; i--) {
                        document.body.removeChild(popups[i]);
                    }
                    if (e.target.classList.contains('button-abort') || e.target.parentNode.classList.contains('button-abort')) {
                        // IMPORTANT: remove event listener from view
                        document.body.removeEventListener('click', context.eventListeners['click']);
                    }
                    document.body.addEventListener('click', this.eventListeners['click'] = function (e) {
                        onBodyClicked(e, that);
                    });
                }
            };
        }
        // initialize click event handler for info windows

    },

    _export_vouchers () {
        const that =this;

        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/voucher_types/export/xls/'+that.model.get("id"), true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {


            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, that.model.get("name")+".xlsx");

        };

        xmlHttp.send(null);


    }
});